import MHeader from './src/index'
import { reactToCwp } from '../../../common/react-utils.jsx'

export default reactToCwp(MHeader)
